module.exports = __webpack_public_path__ + "media/flags/gl-b766ea53.gif";